import React from 'react';

export const configureSortComponent = (headerProps, currentSort) => {

    return <></>;
}
